import { MDSLayout } from '@antv/layout/lib/layout/mds';

export default MDSLayout;
